export const FORM_FIELD_VARIANT_TYPES = {
  LARGE: 'large',
  REGULAR: 'regular'
};

export const COMMON_FORM_FIELD_CLASSES =
  'w-100 ba br3 b--light-gray bg-white input-reset';

export const COMMON_LABEL_CLASSES = 'f2 fw-medium dark-gray';
